<script lang="ts">
	import { format } from 'svelte-i18n';
	import TemplateToggleSettings from '../Components/TemplateToggleSettings.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<TemplateToggleSettings
	{device}
	setting="anti_freeze"
	title={$format('settings_title_enable_anti_freeze', {
		default: 'Enable anti freeze',
	})}
/>
